export default function Theme() {
  let output = { primary: "#1DA57A", sideMenu: "#0f172a" };
  return output;
}
